var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.99 92.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#636154;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BASE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-1",
    d: "M42.09,92.93h-.6c-.42,0-.85,0-1.28,0-6.62-.2-13.23-3.66-19.1-10a50.45,50.45,0,0,1-10.7-18.35c-.14-.43-.24-.85-.34-1.26a9.15,9.15,0,0,1-6.86-4.8A28.16,28.16,0,0,1,0,45.1c0-4,1.88-6.46,5.59-7.39q-.15-.87-.27-1.74c-1.05-8.1.44-14.71,4.54-20.19C17.16,6,27.46.86,41.33,0h.33C55.53.86,65.83,6,73.13,15.78c4.1,5.49,5.59,12.09,4.54,20.19q-.12.87-.27,1.74c3.71.93,5.59,3.41,5.59,7.39a28.27,28.27,0,0,1-3.21,13.4,9.16,9.16,0,0,1-6.86,4.8c-.1.41-.2.83-.34,1.26a50.5,50.5,0,0,1-10.7,18.35c-5.87,6.35-12.48,9.82-19.1,10Zm-.6-5.39h1.12C54.46,87.19,64.44,72.67,67.45,63c.16-.53.29-1.12.42-1.75.07-.33.14-.66.22-1l.47-2,2.08-.06C73.53,58.05,74.46,57,75,56A22.92,22.92,0,0,0,77.61,45.1c0-1.6-.23-2-2.28-2.32-.4-.06-.8-.14-1.14-.2l-.39-.08L71.23,42l.42-2.59c.09-.53.18-1,.26-1.53.17-.91.32-1.78.43-2.61.85-6.64-.29-12-3.51-16.27C62.56,10.62,53.61,6.16,41.49,5.39,29.37,6.16,20.43,10.62,14.16,19c-3.23,4.3-4.37,9.63-3.51,16.27.11.83.26,1.7.42,2.62.08.49.17,1,.26,1.52L11.75,42l-2.57.49-.38.07a11.23,11.23,0,0,1-1.17.21c-2,.29-2.26.73-2.26,2.32A22.79,22.79,0,0,0,8,56c.58,1.08,1.51,2.09,4.4,2.17l2.08.06.47,2,.21,1c.14.63.26,1.22.42,1.75,3,9.71,13,24.23,24.84,24.59.35,0,.69,0,1,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29-2",
    "data-name": "Group 29-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-1",
    d: "M16.35,33.54l-.7-2.34q1.5-.45,2.94-.75l.5,2.39C18.21,33,17.29,33.26,16.35,33.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-1",
    d: "M33.68,34.88a16.82,16.82,0,0,0-3.36-1.63l.81-2.3A18.51,18.51,0,0,1,35,32.82Zm-7-2.47a19.91,19.91,0,0,0-3.78-.1l-.15-2.44A22.16,22.16,0,0,1,27,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-1",
    d: "M38.52,39.26a20.31,20.31,0,0,0-1.88-2l1.69-1.77a25,25,0,0,1,2.09,2.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-1",
    d: "M16.88,55a17.91,17.91,0,0,1-2.1-2.34l2-1.48a16.61,16.61,0,0,0,1.82,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-1",
    d: "M23.83,58.48a11.89,11.89,0,0,1-3.77-1.21l1.11-2.17a9.71,9.71,0,0,0,3,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-1",
    d: "M27.75,58.46,27.4,56A14.92,14.92,0,0,0,30,55.41l.76,2.32A16.93,16.93,0,0,1,27.75,58.46Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-1",
    d: "M50.91,73.39a17.17,17.17,0,0,0-7.58-2.48A21.29,21.29,0,0,0,33,73.26a2.29,2.29,0,0,0-1.25,1.25,1.63,1.63,0,0,0,.17,1.28,1.81,1.81,0,0,0,2.46.72l.17-.1c5.09-2.62,10-2.6,14.66,0a2,2,0,0,0,1,.28,1.69,1.69,0,0,0,1.47-.85,1.77,1.77,0,0,0,.22-1.31A2,2,0,0,0,50.91,73.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-1",
    d: "M36.46,63.09A6.15,6.15,0,0,0,41.68,66h0a6.25,6.25,0,0,0,5.63-3.13,1.72,1.72,0,0,0-.45-2.4h0a1.69,1.69,0,0,0-2.36.44l0,.06c-1.5,1.92-3.63,2-5.14.07A1.72,1.72,0,0,0,37,60.42l-.12.07A1.78,1.78,0,0,0,36.37,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-1",
    d: "M18.45,44.45a19.5,19.5,0,0,1,8.88-.72,18.34,18.34,0,0,1,2.62.68,13.61,13.61,0,0,0,4.1.84,6.72,6.72,0,0,0,1.26-.12,2.17,2.17,0,0,0,1.76-1.32A1.75,1.75,0,0,0,36.51,42,4.66,4.66,0,0,0,34,41l-2.46-.48a38.82,38.82,0,0,0-7.59-1q-.9,0-1.8.09A7.65,7.65,0,0,0,18.43,41c-.88.59-1.79,1.3-1.82,2.2a1.36,1.36,0,0,0,.55,1.12A1.41,1.41,0,0,0,18.45,44.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-1",
    d: "M33.73,51.41a8.15,8.15,0,0,1,1.3-.19,1.05,1.05,0,0,0,.15-2.08,17.41,17.41,0,0,0-3.81-.38c-1.25,0-2.49.09-3.69.17L26.34,49a13.69,13.69,0,0,1-7.65-1.63l-.16-.06-.24,0a.9.9,0,0,0-.91.9.93.93,0,0,0,.31.69c.21.18.41.38.64.6a10.27,10.27,0,0,0,1.37,1.18l.3.2a12.24,12.24,0,0,0,2.13,1,15.93,15.93,0,0,0,4.42.94c.54,0,1.09.07,1.64.07a9.21,9.21,0,0,0,3-.43,11.27,11.27,0,0,0,1.24-.53A7,7,0,0,1,33.73,51.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    className: "cls-1",
    d: "M65.89,41a7.61,7.61,0,0,0-3.7-1.42,17.93,17.93,0,0,0-1.8-.09,38.58,38.58,0,0,0-7.63,1L50.34,41A4.66,4.66,0,0,0,47.81,42a1.75,1.75,0,0,0-.56,1.79A2.17,2.17,0,0,0,49,45.13a6.75,6.75,0,0,0,1.27.12,13.74,13.74,0,0,0,4.1-.84A17.87,17.87,0,0,1,57,43.73a19.52,19.52,0,0,1,8.88.72,1.81,1.81,0,0,0,.51.08,1.27,1.27,0,0,0,.78-.25,1.35,1.35,0,0,0,.56-1.12C67.68,42.26,66.77,41.54,65.89,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-1",
    d: "M66,47.3h0l-.17,0-.22.09A13.71,13.71,0,0,1,58,49l-1.34-.09c-1.2-.08-2.44-.17-3.69-.17a17.4,17.4,0,0,0-3.81.37,1.06,1.06,0,0,0,.14,2.09,8.27,8.27,0,0,1,1.31.19,6.4,6.4,0,0,1,1.33.54,10.9,10.9,0,0,0,1.22.52,9.14,9.14,0,0,0,3,.43c.55,0,1.1,0,1.64-.07a15.86,15.86,0,0,0,4.41-.94,11.91,11.91,0,0,0,2.13-1l.3-.19A10,10,0,0,0,66,49.47c.2-.2.4-.4.62-.58a.9.9,0,0,0,.14-1.2A.91.91,0,0,0,66,47.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    className: "cls-1",
    d: "M68,33.54l.71-2.34c-1-.3-2-.55-2.94-.75l-.51,2.39C66.11,33,67,33.26,68,33.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    className: "cls-1",
    d: "M49.34,32.82A19,19,0,0,1,53.19,31L54,33.26a16.78,16.78,0,0,0-3.36,1.62Zm8-2.84a23.12,23.12,0,0,1,4.24-.11l-.16,2.44a20.77,20.77,0,0,0-3.78.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-1",
    d: "M45.8,39.26a21.44,21.44,0,0,1,1.88-2L46,35.44a24.87,24.87,0,0,0-2.09,2.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-1",
    d: "M67.44,55a19.48,19.48,0,0,0,2.1-2.34l-2-1.48a17.48,17.48,0,0,1-1.82,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-1",
    d: "M60.48,58.48a12,12,0,0,0,3.78-1.21L63.14,55.1a9.63,9.63,0,0,1-3,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-1",
    d: "M56.57,58.46,56.92,56a15,15,0,0,1-2.65-.63l-.76,2.32A17,17,0,0,0,56.57,58.46Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreat2);
export default __webpack_public_path__ + "static/media/Treat2.1d26e11df6868211fd99ebe7813cf833.svg";
export { ForwardRef as ReactComponent };